import { localStorageInstance } from '@gem/modules/storage';
import { parseJSON } from '@gem/utils';

import { ITenantRouterUrls } from 'APP/model/tenantRouter/tenantRouterModel.types';

const TENANT_ROUTING_STORAGE_KEY = 'tenant_routing';

export function set(urls: ITenantRouterUrls): void {
  localStorageInstance.setItem(TENANT_ROUTING_STORAGE_KEY, JSON.stringify(urls));
}

export function get(): ITenantRouterUrls | null {
  const jsonStr = localStorageInstance.getItem(TENANT_ROUTING_STORAGE_KEY) || '';
  if (!jsonStr) {
    return null;
  }
  return {
    bffUrl: '',
    wsApiUrl: '',
    liveKitCallsUrl: '',
    unauthorizedUrl: '',
    ...(parseJSON<ITenantRouterUrls>(jsonStr) || {}),
  };
}

export function update(urls: Partial<ITenantRouterUrls>): void {
  const currentTenantRouting = get() || ({} as ITenantRouterUrls);
  set({ ...currentTenantRouting, ...urls });
}

export function remove(): void {
  return localStorageInstance.removeItem(TENANT_ROUTING_STORAGE_KEY);
}
